import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import { connect } from 'react-redux';
import Head from 'next/head';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import defaultStaticPage, {
  defaultPageStaticContext,
} from '~/../hocs/defaultStaticPage';
import CollectionPageDetail from '~/containers/CollectionPageDetail';
import {
  loadCollectionOfMonths,
  loadDataCollectionById,
} from '~/containers/CollectionPageDetail/actions';
import Layout from '~/containers/Layout';
import config from '~/config';
import { loadPinterest } from '~/utils/file-helper';
import HrefLangs from '~/components/HrefLangs';

const mapStateToProps = (state) => ({
  collection: state.collection,
  location: state.collection.query,
});
@connect(mapStateToProps)
@defaultStaticPage(['page-collections', 'common'])
class Collection extends React.Component {
  componentDidMount() {
    loadPinterest();
  }

  render() {
    const { t, collection, location, query, lng } = this.props;
    const collectionDetail = collection.collectionDetail;
    const catSlugEn = collection.slug.slug_en;
    const totalPage = collection.total_page;
    const meta_description = collectionDetail.meta_description;
    const page = parseInt(location.page);

    const canonical = `${config.getSiteURL()}/collection/${encodeURIComponent(
      query.slug || '',
    ).toLowerCase()}`;

    const hrefPrev = `${canonical}/${page - 1}`;
    const hrefNext = `${canonical}/${page + 1}`;

    let title_tag = collectionDetail.title_tag;
    if (title_tag) {
      if (page > 1) {
        const pageText = t(config.getPrefixContent('page_count'), {
          page,
        });
        title_tag += ' ' + pageText;
      } else {
        title_tag += t(config.getPrefixContent('title_tag'));
      }
    }

    const titleDefault =
      page > 1
        ? t(
          config.getPrefixContent('title_tag_single_collection_default_page'),
          {
            nameCollection: collectionDetail.name?.trim(),
            page: page,
          },
        )
        : t(config.getPrefixContent('title_tag_single_collection_default'), {
          nameCollection: collectionDetail.name?.trim(),
        });

    return (
      <Layout>
        <Head>
          <title>{title_tag || titleDefault}</title>
          <meta
            id="meta-description"
            name="description"
            content={
              meta_description ||
              t(
                config.getPrefixContent(
                  'meta_description_single_collection_default',
                ),
                {
                  nameCollection: collectionDetail.name?.toLowerCase().trim(),
                  countCollection: collectionDetail.total_images,
                },
              )
            }
          />
          {page === 1 ? '' : <link rel="prev" href={hrefPrev} />}
          {page >= totalPage ? '' : <link rel="next" href={hrefNext} />}
          <HrefLangs
            pagePath={`/collection/${encodeURIComponent(query.slug)}${page === 1 ? '' : `/${page}`
              }`}
            lng={lng}
          />

          <meta property="og:title" content={title_tag || titleDefault} />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content={`${canonical}${page === 1 ? '' : `/${page}`}`}
          />
          {lng === 'en' ? (
            <meta property="og:locale" content={'en_US'} />
          ) : (
            <meta
              property="og:locale"
              content={lng + '_' + lng?.toUpperCase()}
            />
          )}

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:url"
            content={`${canonical}${page === 1 ? '' : `/${page}`}`}
          />
          <meta name="twitter:title" content={title_tag || titleDefault} />
          <meta name="twitter:site" content={`${config.getSiteURL()}`} />
          <meta name="twitter:creator" content={`@${config.getName()}`} />
        </Head>
        <CollectionPageDetail catSlugEn={catSlugEn} query={this.props.query} />
      </Layout>
    );
  }
}

export const getStaticPaths = async () => {
  const paths = [];

  return { paths, fallback: 'blocking' };
};

export const getStaticProps = wrapper.getStaticProps((store) => async (ctx) => {
  const i18nProps = await serverSideTranslations(
    ctx.locale || process.env.LANGUAGE,
    ['page-collections', 'common'],
    nextI18nextConfig,
  );

  const { params } = ctx;

  const { currentLanguage, api } = await defaultPageStaticContext({
    ...ctx,
    store,
  });

  let slug = params?.slug;
  let id = -1;
  if (slug) {
    slug = slug.split('?')[0];
    const arrayHandle = slug.split('-');
    id = arrayHandle[arrayHandle.length - 1];
  }

  if (id !== -1) {
    // const language = store.getState().language.currentLanguage;
    const language = currentLanguage;

    store.dispatch(
      loadDataCollectionById(
        {
          lang: language,
          id: id,
          page: parseInt(params?.page) || 1,
        },
        api,
      ),
    );
  }
  store.dispatch(
    loadCollectionOfMonths(
      {
        lang: currentLanguage,
      },
      api,
    ),
  );

  // end the saga
  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      ...i18nProps,
      query: params,
    },
    revalidate: 60 * 60 * 24 * 7, // revalidate every 7 days
  };
});

export default Collection;
